(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fl-hero"] && !Shopify.designMode) return;
  try {
    
  /* Hero → header logo "landing" animation (ported from mockup/index.html).
     The giant hero wordmark IS the brand mark at the top. As you scroll it scales
     down + slides + lifts so it lands exactly on the header-logo slot; the header
     logo crossfades in only in the final sliver (so the two never show duplicated).
     The desktop nav left-aligns into the empty logo slot at the top and slides
     right in lock-step. Mobile runs the SAME landing — the wordmark lands on the
     header logo docked left next to the hamburger (mobile_logo_position: left) and
     stays visible; the nav slide is simply skipped (the nav lives in the drawer). */
  (function () {
    var root = document.documentElement;
    var wordmark = document.querySelector('.hero-wordmark[data-hero-wordmark]');
    var hero = wordmark && wordmark.closest('.hero');
    if (!wordmark || !hero) return;
    root.classList.add('has-hero-wordmark');

    var topbar = document.querySelector('.fl-topbar');
    var headerLogo = document.querySelector('.header__heading-link');
    var nav = document.querySelector('.header__inline-menu');
    var promo = document.querySelector('.announcement-bar-section');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function promoH() { return promo ? promo.offsetHeight : 0; }
    function setPromoVar() { if (promo) root.style.setProperty('--fl-promo-h', promoH() + 'px'); }
    setPromoVar();

    /* Reduced motion or nothing to land into → solid header + visible logo, no animation. */
    if (reduce || !headerLogo || !topbar) {
      root.classList.add('is-hero-scrolled');
      if (headerLogo) headerLogo.style.opacity = '1';
      return;
    }

    var HEADER_BG_START = 0.55, FADE_START = 0.99, LIFT_RISE = 56;
    var endScale = 0.18, endTx = 0, endTy = 0, wmH = 0, wmDocTop = 0, wmLeft = 16, logoTop = 14, liftScrollY = 800, navShift = 0;
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function measure() {
      wordmark.style.transform = 'scale(1)';
      wordmark.style.opacity = '1';
      var wm = wordmark.getBoundingClientRect();
      wmH = wm.height; wmLeft = wm.left; wmDocTop = wm.top + (window.scrollY || window.pageYOffset);

      /* Logo's landed position: neutralise the topbar's promo-slide transform, read
         it, then subtract the promo height (where the logo sits once the strip slid). */
      var prevT = topbar.style.transform; topbar.style.transform = 'none';
      var prevO = headerLogo.style.opacity; headerLogo.style.opacity = '0';
      var tl = headerLogo.getBoundingClientRect();
      headerLogo.style.opacity = prevO; topbar.style.transform = prevT;

      logoTop = tl.top - promoH();
      endScale = tl.height / (wmH || 1);
      endTx = tl.left - wmLeft;
      endTy = -LIFT_RISE;
      /* Reset any prior inline transform before measuring the nav's natural left,
         or a re-measure (resize / wide screens) reads the already-shifted position
         and computes navShift too small — leaving the nav stuck mid-slide. */
      if (nav && nav.offsetParent) {
        var prevNavT = nav.style.transform; nav.style.transform = 'none';
        navShift = Math.max(0, nav.getBoundingClientRect().left - tl.left);
        nav.style.transform = prevNavT;
      } else {
        navShift = 0;
      }
      liftScrollY = wmDocTop + wmH * (1 - endScale) + endTy - logoTop;
      if (liftScrollY < 1) liftScrollY = 1;
    }

    var tick = false;
    function update() {
      tick = false;
      var scrollY = window.scrollY || window.pageYOffset;
      var p = clamp(scrollY / liftScrollY, 0, 1);
      var s = 1 + (endScale - 1) * p;
      wordmark.style.transform = 'translate3d(' + (endTx * p) + 'px,' + (endTy * p) + 'px,0) scale(' + s + ')';
      var fadeP = clamp((p - FADE_START) / (1 - FADE_START), 0, 1);
      wordmark.style.opacity = String(1 - fadeP);
      headerLogo.style.opacity = String(fadeP);
      if (nav && navShift) nav.style.transform = 'translateX(' + (-navShift * (1 - p)) + 'px)';
      root.classList.toggle('is-hero-scrolled', p >= HEADER_BG_START);
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(update); } }

    function start() { measure(); update(); window.addEventListener('scroll', onScroll, { passive: true }); }
    window.addEventListener('resize', function () { setPromoVar(); measure(); update(); }, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(start); } else { window.addEventListener('load', start); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.fl-pdp');
    if (!root) return;
    var form = root.querySelector('product-form form');
    var idInput = root.querySelector('[data-variant-id-input]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabel = root.querySelector('[data-add-label]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var sizeGroup = root.querySelector('[data-size-group]');
    var hasSize = !!sizeGroup;
    var chosen = root.querySelector('[data-variant-ready]') ? true : false;

    function setLabel(t) { if (addLabel) addLabel.textContent = t; if (stickyAdd) stickyAdd.textContent = t; }

    // Size selection → set the form's variant id + enable Add.
    if (sizeGroup) {
      sizeGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('.size');
        if (!btn || btn.disabled) return;
        sizeGroup.querySelectorAll('.size').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        if (idInput) { idInput.value = btn.getAttribute('data-variant-id'); idInput.removeAttribute('disabled'); }
        chosen = true;
        if (addBtn) addBtn.removeAttribute('disabled');
        setLabel('Add to bag');
      });
    }

    // Sticky bar: no size yet → nudge the size selector into view; else trigger the real add.
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (hasSize && !chosen) { if (sizeGroup) sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (addBtn) addBtn.click();
      });
    }

    // Size guide → open the Sizing accordion.
    var guide = root.querySelector('[data-size-guide]');
    if (guide) guide.addEventListener('click', function (e) {
      e.preventDefault();
      var s = root.querySelector('#fl-sizing');
      if (s) { s.open = true; s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });

    // Save → the shared Favourites store (assets/fl-faves.js) wires + reflects
    // [data-save][data-handle] globally: click-to-toggle, aria-pressed/.is-saved,
    // and the "Save"/"Saved" label. No per-page handler needed.

    // Gallery — one shared scrollLeft track drives the thumbnail rail (desktop),
    // the prev/next click-zones (desktop), and the dots (mobile). Native swipe on
    // touch, programmatic scroll on desktop; the scroll handler keeps all indicators
    // in sync, so left/right clicks and thumb taps move through the same image list.
    var gallery = root.querySelector('[data-pdp-gallery]');
    if (gallery) {
      var slideCount = gallery.querySelectorAll('.pdp__photo').length;
      var dotsWrap = root.querySelector('[data-pdp-dots]');
      var thumbsWrap = root.querySelector('[data-pdp-thumbs]');
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.children) : [];
      var clampIdx = function (i) { return Math.max(0, Math.min(slideCount - 1, i)); };
      var curIdx = function () { return gallery.clientWidth ? clampIdx(Math.round(gallery.scrollLeft / gallery.clientWidth)) : 0; };
      var goTo = function (i, smooth) { gallery.scrollTo({ left: clampIdx(i) * gallery.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); };
      var sync = function () {
        var i = curIdx();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        thumbs.forEach(function (t, j) {
          var on = j === i;
          t.classList.toggle('is-active', on);
          if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
      };
      dots.forEach(function (d, j) { d.addEventListener('click', function () { goTo(j, true); }); });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { goTo(j, true); }); });
      var prevBtn = root.querySelector('[data-pdp-prev]');
      var nextBtn = root.querySelector('[data-pdp-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(curIdx() - 1, true); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(curIdx() + 1, true); });
      var t1 = false;
      gallery.addEventListener('scroll', function () { if (t1) return; t1 = true; requestAnimationFrame(function () { sync(); t1 = false; }); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    // Stage aspect — match each product's own photos (catalog mixes 2:3 leggings &
    // 4:5 bras). Expose --stage-ar for the thumbnails + mobile; on desktop size the
    // stage to the largest box of that ratio fitting BOTH the column width and the
    // viewport-height cap, so the whole image shows with no letterbox band.
    var wrapEl = root.querySelector('.pdp__gallery-wrap');
    var stageEl = root.querySelector('.pdp__stage');
    var thumbsEl = root.querySelector('[data-pdp-thumbs]');
    var firstImg = root.querySelector('.pdp__photo img');
    if (wrapEl && stageEl && firstImg) {
      var DESKTOP = window.matchMedia('(min-width: 990px)');
      var sizeStage = function () {
        var nw = firstImg.naturalWidth, nh = firstImg.naturalHeight;
        if (!nw || !nh) return;
        var ar = nw / nh;
        root.style.setProperty('--stage-ar', nw + ' / ' + nh);
        if (DESKTOP.matches) {
          var railGap = 12; // var(--space-3): rail↔stage gap inside the wrap
          var gridGap = 40; // var(--space-10): gallery↔buy-box column gap
          var rail = thumbsEl ? thumbsEl.getBoundingClientRect().width : 0; // 64px rail (0 if no thumbs)
          var gridEl = root.querySelector('.pdp__grid');
          // Container width is stable (independent of the columns we're about to
          // size), so deriving the image width from it avoids any feedback loop.
          var containerW = gridEl ? gridEl.clientWidth : wrapEl.clientWidth;
          var buyboxW = Math.max(340, Math.min(440, containerW * 0.38));
          var availW = containerW - gridGap - buyboxW - rail - (rail ? railGap : 0);
          // Width-driven only (no viewport-height cap) — like exercere: the photo
          // fills its column width and is as tall as its aspect ratio makes it, so a
          // tall portrait dominates the left column and no blank pools below it. The
          // buy-box is sticky (CSS) and pins beside the scrolling image.
          var w = availW;
          var h = w / ar;
          stageEl.style.width = w + 'px';
          stageEl.style.height = h + 'px';
          // Pin the wrap to the image height so the gallery column never claims
          // more vertical room than the photo — a collapsed buy-box leaves no gap.
          wrapEl.style.height = h + 'px';
          // Size the columns: gallery = rail + image (no horizontal gutter beside
          // the photo), buy-box = bounded width; the grid centres the pair.
          root.style.setProperty('--pdp-gallery-col', (rail + (rail ? railGap : 0) + w) + 'px');
          root.style.setProperty('--pdp-buybox-col', buyboxW + 'px');
        } else {
          stageEl.style.width = '';
          stageEl.style.height = '';
          wrapEl.style.height = '';
          root.style.removeProperty('--pdp-gallery-col');
          root.style.removeProperty('--pdp-buybox-col');
        }
      };
      if (firstImg.complete && firstImg.naturalWidth) { sizeStage(); }
      else { firstImg.addEventListener('load', sizeStage); }
      window.addEventListener('resize', sizeStage);
    }

    // Sticky add-to-bag bar — reveal once the inline Add has scrolled above the viewport,
    // and fade it back out once the footer scrolls into view so it never sits over the footer.
    var bar = root.querySelector('[data-sticky-cta]');
    var footerEl = document.querySelector('.shopify-section-group-footer-group')
                || document.querySelector('footer');
    if (bar && addBtn) {
      bar.setAttribute('aria-hidden', 'false');
      var t2 = false;
      function update() {
        t2 = false;
        var pastInlineAdd = addBtn.getBoundingClientRect().bottom <= 0;
        var footerInView = footerEl ? footerEl.getBoundingClientRect().top <= window.innerHeight : false;
        bar.classList.toggle('is-visible', pastInlineAdd && !footerInView);
      }
      function onScroll() { if (!t2) { t2 = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-wishlist"] && !Shopify.designMode) return;
  try {
    
  /* Reveal only the saved cards; keep the count + empty state in sync. Listens for
     the shared store's change event so un-saving a card here hides it immediately. */
  (function () {
    var root = document.querySelector('.fl-wishlist');
    if (!root) return;
    var grid = root.querySelector('[data-faves-grid]');
    var empty = root.querySelector('[data-faves-empty]');
    var countEl = root.querySelector('[data-faves-pagecount]');
    if (!grid) return;

    function apply() {
      var saved = (window.FRLSFaves && window.FRLSFaves.items()) || [];
      var set = {};
      for (var i = 0; i < saved.length; i++) set[saved[i]] = true;

      var cards = grid.querySelectorAll('.card[data-handle]');
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var on = !!set[cards[j].getAttribute('data-handle')];
        cards[j].classList.toggle('is-shown', on);
        if (on) shown++;
      }
      if (countEl) countEl.textContent = '(' + shown + ')';
      if (empty) empty.hidden = shown > 0;
    }

    document.addEventListener('frls:faves-change', apply);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Footer link groups: collapsible accordions on mobile, always-open columns on
  // desktop (≥990px) with no toggle. A closed <details> won't PAINT its content
  // even with display:block, so desktop must use the real `open` state.
  (function () {
    var desktop = window.matchMedia('(min-width: 990px)');
    var groups = document.querySelectorAll('.footer-accordion');
    function sync() {
      groups.forEach(function (d) { d.open = desktop.matches; });
    }
    // On desktop the summary is inert (no toggle); if anything closes a group, reopen it.
    groups.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (desktop.matches && !d.open) d.open = true;
      });
    });
    sync();
    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else if (desktop.addListener) desktop.addListener(sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
